/** 
  Author: Lokesh Arora - lokesh.arora@enabledata.com
  Purpose: Clients services
  Date: April 2020
**/

import API from '../utils/api';
import LocalStorageService from './localStorage';
import { globalPageLimit } from '../constants/applicationConstants';
const localStorageService = LocalStorageService.getService();

export const getClientList = (payload) => {
  const queryString = (payload) ? `${payload}&limit=${globalPageLimit.CLIENT_LIMIT}` : `limit=${globalPageLimit.CLIENT_LIMIT}`;
  return API.get(`clients/clients?${queryString}`, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};